import styled from '@emotion/styled'

import { combineAriaDescribedBy } from '../Input/ArcadeHelpText'

export interface ArcadeRadioButtonProps extends React.InputHTMLAttributes<HTMLInputElement> {
  checked?: boolean
  defaultChecked?: boolean
  disabled?: boolean
  isSegmentedControl?: boolean
  helpTextId?: string
}

const RADIO_HEIGHT_AND_WIDTH = '1.5rem'

const HiddenRadio = styled.input`
  appearance: none;
  opacity: 0;
  position: absolute;
  left: 0;
  top: 0;
  width: ${RADIO_HEIGHT_AND_WIDTH};
  height: ${RADIO_HEIGHT_AND_WIDTH};
  cursor: pointer;
  outline: none;

  &:disabled {
    cursor: not-allowed;
  }
`

const VisibleRadio = styled.div`
  width: ${RADIO_HEIGHT_AND_WIDTH};
  height: ${RADIO_HEIGHT_AND_WIDTH};
  border-radius: 50%;
  border: ${({ theme }) => theme.arcadeColors.component.radioInactiveBorderDefault} solid 0.125rem;

  /* checked */
  label:has(input:checked) & {
    border-width: 0.5rem;
    border-color: ${({ theme }) => theme.arcadeColors.component.radioActiveBorderDefault};
  }

  /* unchecked & disabled */
  label:has(input:disabled) & {
    border-color: ${({ theme }) => theme.arcadeColors.component.radioInactiveBorderDisabled};
  }

  /* checked & disabled */
  label:has(input:checked):has(input:disabled) & {
    border-color: ${({ theme }) => theme.arcadeColors.component.radioActiveBorderDisabled};
  }
`

export default ({ isSegmentedControl = false, ...props }: ArcadeRadioButtonProps) => {
  const { 'aria-describedby': ariaDescribedBy, helpTextId, ...restProps } = props
  const combinedAriaDescribedBy = combineAriaDescribedBy(ariaDescribedBy, helpTextId)

  return (
    <>
      <HiddenRadio
        type="radio"
        {...restProps}
        data-testid="hidden-radio"
        aria-checked={props.checked}
        aria-describedby={combinedAriaDescribedBy}
      />
      {!isSegmentedControl && <VisibleRadio data-testid="visible-radio" />}
    </>
  )
}
